import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Card } from '@/components/ui/card';
import { Users, TrendingUp, Zap } from 'lucide-react';

export const SocialProof = () => {
  const [stats, setStats] = useState({
    totalReaders: 0,
    activeToday: 0,
    articlesRead: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      // Use reading_streaks as proxy for total readers (each user who has read at least once)
      const { count: readersCount } = await supabase
        .from('reading_streaks')
        .select('*', { count: 'exact', head: true });

      // Get users active today by fetching unique user_ids from history
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const { data: activeUsers } = await supabase
        .from('user_content_history')
        .select('user_id')
        .gte('last_viewed_at', today.toISOString());

      // Count unique active users
      const uniqueActive = new Set(activeUsers?.map(u => u.user_id)).size;

      // Get total articles read
      const { data: totalReads } = await supabase
        .from('reading_streaks')
        .select('total_articles_read');

      const totalArticles = totalReads?.reduce((sum, user) => sum + (user.total_articles_read || 0), 0) || 0;

      setStats({
        totalReaders: readersCount || 0,
        activeToday: uniqueActive,
        articlesRead: totalArticles
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  if (stats.totalReaders === 0) return null;

  return (
    <Card className="p-6 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="grid grid-cols-3 gap-6 text-center">
        <div>
          <Users className="h-6 w-6 mx-auto mb-2 text-primary" />
          <p className="text-2xl font-bold">{stats.totalReaders.toLocaleString()}</p>
          <p className="text-sm text-muted-foreground">Readers</p>
        </div>
        <div>
          <Zap className="h-6 w-6 mx-auto mb-2 text-primary" />
          <p className="text-2xl font-bold">{stats.activeToday.toLocaleString()}</p>
          <p className="text-sm text-muted-foreground">Active Today</p>
        </div>
        <div>
          <TrendingUp className="h-6 w-6 mx-auto mb-2 text-primary" />
          <p className="text-2xl font-bold">{stats.articlesRead.toLocaleString()}</p>
          <p className="text-sm text-muted-foreground">Articles Read</p>
        </div>
      </div>
    </Card>
  );
};
